import { TextInput } from '@any-ui-react/core';
import { useFormContext, useWatch } from 'react-hook-form';

import { CountrySelectSingle } from '@/common/components/shared/select/country/CountrySelect';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { useEmployeeAccess } from '@/common/hooks/employees/useEmployeeAccess';
import type { EmployeePersonalInformationFormDataType } from '@/common/types';

export const BankFormFields = () => {
  const {
    formState: { errors },
    register,
    setValue,
    control,
  } = useFormContext<EmployeePersonalInformationFormDataType>();
  const bankCountryCode = useWatch({ control, name: 'bankCountryCode' });

  const { employeeDetail } = useEmployeeDetailContext();
  const isNewRecord = !employeeDetail.id;
  const { hasEmployeePersonalInformationEditAccess } = useEmployeeAccess();
  const isEditable = hasEmployeePersonalInformationEditAccess || isNewRecord;

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">Bank</div>
      <fieldset className="form-fieldset">
        <CountrySelectSingle
          className="col-span-2 lg:col-span-1"
          disabled={!isEditable}
          error={errors.bankCountryCode?.message}
          label="Bank Country"
          placeholder="Select Bank Country"
          value={bankCountryCode}
          onChange={option => {
            setValue('bankCountryCode', option?.value as string);
          }}
        />
        <TextInput
          {...register('bankName')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Bank Name"
          placeholder="Enter Bank Name"
        />
        <TextInput
          {...register('branchName')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Branch Name"
          placeholder="Enter Branch Name"
        />
        <TextInput
          {...register('accountNumber')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Account Number"
          placeholder="Enter Account Number"
        />
        <TextInput
          {...register('accountHolderName')}
          autoComplete="off"
          className="col-span-2 lg:col-span-1"
          data-1p-ignore={true}
          disabled={!isEditable}
          label="Account Holder Name"
          placeholder="Enter Account Holder Name"
        />
      </fieldset>
    </div>
  );
};
